import React, { useState } from 'react';
import styled from 'styled-components';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 20px;\n  height: 30px;\n  align-self: center;\n  min-width: 70px;\n  color: blue;\n  padding: 0;\n  background: transparent;\n  border-radius: 0;\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  justify-self: end;\n  text-align: right;\n  margin-right: 30px;\n  height: 100%;\n  display: flex;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: normal;\n  margin-bottom: 5px;\n  margin-top: 0;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 5px;\n  margin-top: 0;\n  font-size: 14px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  justify-self: start;\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  justify-content: center;\n  color: #0d0d0d;\n  font-size: 12px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 80px;\n  border-radius: 15px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  justify-self: start;\n  padding-left: 10px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  background: transparent;\n  border: none;\n  font-size: 15px;\n  text-align: center;\n  text-decoration: none;\n  border-radius: 14px;\n  -webkit-font-smoothing: subpixel-antialiased;\n  border: 0;\n  width: 17px;\n  height: 17px;\n  line-height: 17px;\n  color: #b1b1b3;\n  background: #efefef;\n  cursor: pointer;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  justify-self: end;\n  align-self: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: sans-serif;\n  display: grid;\n  grid-template-columns: 20px 100px auto 100px;\n  position: ", ";\n  top: ", ";\n  left: ", ";\n  right: ", ";\n  width: ", ";\n  height: 100px;\n  color: #000;\n  background: #f2f2f2;\n  box-shadow: ", ";\n  padding: 10px;\n  border-radius: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BannerContainer = styled.div(_templateObject(), function (_ref) {
  var position = _ref.position;
  return position === 'top' ? 'absolute' : 'fixed';
}, function (_ref2) {
  var position = _ref2.position;
  return position === 'top' ? '0' : '85%';
}, function (_ref3) {
  var position = _ref3.position;
  return position === 'top' ? '0' : '20px';
}, function (_ref4) {
  var position = _ref4.position;
  return position === 'top' ? '0' : '20px';
}, function (_ref5) {
  var position = _ref5.position;
  return position === 'top' ? '100%' : 'auto';
}, function (_ref6) {
  var position = _ref6.position;
  return position === 'top' ? '0 1px 2px rgba(0, 0, 0, 0.8) inset, 0 1px 1px rgba(255, 255, 255, 0.3)' : '5px 5px 15px 0px rgba(138, 138, 138, 0.6)';
}, function (_ref7) {
  var position = _ref7.position;
  return position === 'top' ? '0' : '10px';
});
var CloseButtonContainer = styled.div(_templateObject2());
var CloseButton = styled.button(_templateObject3());
var AppImageContainer = styled.div(_templateObject4());
var AppImage = styled.img(_templateObject5());
var AppInfoContainer = styled.div(_templateObject6());
var AppName = styled.div(_templateObject7());
var AppPublisher = styled.div(_templateObject8());
var AppLinkContainer = styled.div(_templateObject9());
var AppLinkButton = styled.a(_templateObject10());

var AppBanner = function AppBanner(_ref8) {
  var _ref8$appInfo = _ref8.appInfo,
      appInfo = _ref8$appInfo === void 0 ? {} : _ref8$appInfo,
      _ref8$hidden = _ref8.hidden,
      hidden = _ref8$hidden === void 0 ? false : _ref8$hidden,
      _ref8$position = _ref8.position,
      position = _ref8$position === void 0 ? 'bottom' : _ref8$position,
      _ref8$onClose = _ref8.onClose,
      onClose = _ref8$onClose === void 0 ? function () {} : _ref8$onClose,
      style = _ref8.style;

  var _useState = useState(!hidden),
      show = _useState[0],
      setShow = _useState[1];

  var imageUrl = appInfo.imageUrl,
      name = appInfo.name,
      publisher = appInfo.publisher,
      infoText = appInfo.infoText,
      linkButtonText = appInfo.linkButtonText,
      linkUrl = appInfo.linkUrl;
  return show && /*#__PURE__*/React.createElement(BannerContainer, {
    position: position,
    style: style
  }, /*#__PURE__*/React.createElement(CloseButtonContainer, null, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: function onClick() {
      console.log('closed');
      setShow(false);
      onClose();
    }
  }, "X")), /*#__PURE__*/React.createElement(AppImageContainer, null, /*#__PURE__*/React.createElement(AppImage, {
    src: imageUrl
  })), /*#__PURE__*/React.createElement(AppInfoContainer, null, /*#__PURE__*/React.createElement(AppName, null, name), /*#__PURE__*/React.createElement(AppPublisher, null, publisher), /*#__PURE__*/React.createElement(AppPublisher, null, infoText)), /*#__PURE__*/React.createElement(AppLinkContainer, null, /*#__PURE__*/React.createElement(AppLinkButton, {
    href: linkUrl,
    target: "_blank"
  }, linkButtonText)));
};

export default AppBanner;